/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type ListingWorkItemsQueryVariables = Types.Exact<{
    input: Types.YourWorkItemsInput;
}>;

export type ListingWorkItemsQuery = {
    __typename: 'Query';
    yourWorkItems: {
        __typename: 'YourWorkItemsResult';
        pageCount: number;
        resultCount: number;
        allCount: number;
        inProgressCount: number;
        completedCount: number;
        canceledCount: number;
        items: Array<
            | ({ __typename: 'StandardWorkItem' } & YourWorkItem_StandardWorkItemFragment)
            | ({ __typename: 'OrderWorkItem' } & YourWorkItem_OrderWorkItemFragment)
        >;
    };
};

export type OrderWorkSubItem_ProjectFragment = {
    __typename: 'OrderWorkSubItemProject';
    id: string;
    state: Types.OrderSubItemState;
    brief: Types.Maybe<{
        __typename: 'StructuredBrief';
        id: string;
        title: string;
        category: Types.Maybe<{ __typename: 'Category'; title: string }>;
    }>;
    project: Types.Maybe<{ __typename: 'Project' } & OrderWorkProjectSubItem_ProjectFragment>;
    product: { __typename: 'ProductFixedPriceProject'; title: string };
    projectContextMessageAndActions: Types.Maybe<
        | ({
              __typename: 'ContextMessageAndActionsCompletedProject';
          } & OrderWorkProjectSubItem_ContextMessageAndActions_ContextMessageAndActionsCompletedProject_Fragment)
        | ({
              __typename: 'ContextMessageAndActionsLockedProject';
          } & OrderWorkProjectSubItem_ContextMessageAndActions_ContextMessageAndActionsLockedProject_Fragment)
        | ({
              __typename: 'ContextMessageAndActionsStartedProject';
          } & OrderWorkProjectSubItem_ContextMessageAndActions_ContextMessageAndActionsStartedProject_Fragment)
        | ({
              __typename: 'ContextMessageAndActionsInvitedProject';
          } & OrderWorkProjectSubItem_ContextMessageAndActions_ContextMessageAndActionsInvitedProject_Fragment)
    >;
    job: Types.Maybe<{ __typename: 'JobEntity'; id: string }>;
};

export type YourWorkItem_StandardWorkItemFragment = {
    __typename: 'StandardWorkItem';
    id: string;
    title: string;
    category: Types.Maybe<string>;
    status: Types.WorkItemStatus;
    linkUrl: string;
    stateDescription: string;
    featuredDesignerAvatars: Array<string>;
    subtitle: string;
    contextMessage: string;
    hasError: boolean;
    canDelete: boolean;
    type: Types.WorkItemType;
    typeId: string;
    deleteActionTitle: string;
    collaborators: Array<{ __typename: 'WorkItemCollaborator'; displayName: string; id: number }>;
    icon: {
        __typename: 'WorkItemIcon';
        type: string;
        name: string;
        url: string;
        signedFileUrl: string;
    };
    stage: {
        __typename: 'WorkItemStage';
        message: string;
        styleVariation: string;
        preTranslatedDateMessage: string;
        date: Types.Maybe<any>;
    };
    actions: Array<{
        __typename: 'WorkItemAction';
        title: string;
        url: string;
        openInNewTab: boolean;
    }>;
};

export type YourWorkItem_OrderWorkItemFragment = {
    __typename: 'OrderWorkItem';
    id: string;
    status: Types.WorkItemStatus;
    createdAt: any;
    items: Array<{ __typename: 'OrderWorkSubItemProject' } & OrderWorkSubItem_ProjectFragment>;
};

export type OrderWorkProjectSubItem_ProjectFragment = {
    __typename: 'Project';
    id: string;
    title: string;
    status: Types.ProjectStatus;
    createdAt: any;
    category: Types.Maybe<{ __typename: 'Category'; id: number; title: string }>;
    designer: Types.Maybe<{
        __typename: 'User';
        id: string;
        displayName: string;
        urlToken: string;
        profile: { __typename: 'Profile'; id: string; avatarUrl: string };
    }>;
};

export type OrderWorkProjectSubItem_ContextMessageAndActions_ContextMessageAndActionsCompletedProject_Fragment =
    {
        __typename: 'ContextMessageAndActionsCompletedProject';
        contextMessage: Types.Maybe<Types.WorkItemProjectContextMessage>;
        actions: Array<Types.WorkItemProjectAction>;
    };

export type OrderWorkProjectSubItem_ContextMessageAndActions_ContextMessageAndActionsLockedProject_Fragment =
    {
        __typename: 'ContextMessageAndActionsLockedProject';
        contextMessage: Types.Maybe<Types.WorkItemProjectContextMessage>;
        actions: Array<Types.WorkItemProjectAction>;
    };

export type OrderWorkProjectSubItem_ContextMessageAndActions_ContextMessageAndActionsStartedProject_Fragment =
    {
        __typename: 'ContextMessageAndActionsStartedProject';
        contextMessage: Types.Maybe<Types.WorkItemProjectContextMessage>;
        actions: Array<Types.WorkItemProjectAction>;
        finishRequestId: Types.Maybe<number>;
    };

export type OrderWorkProjectSubItem_ContextMessageAndActions_ContextMessageAndActionsInvitedProject_Fragment =
    {
        __typename: 'ContextMessageAndActionsInvitedProject';
        contextMessage: Types.Maybe<Types.WorkItemProjectContextMessage>;
        actions: Array<Types.WorkItemProjectAction>;
        awaitingPaymentInvoiceCount: number;
        firstInvoiceAmount: number;
    };

export type OrderWorkProjectSubItem_ContextMessageAndActionsFragment =
    | OrderWorkProjectSubItem_ContextMessageAndActions_ContextMessageAndActionsCompletedProject_Fragment
    | OrderWorkProjectSubItem_ContextMessageAndActions_ContextMessageAndActionsLockedProject_Fragment
    | OrderWorkProjectSubItem_ContextMessageAndActions_ContextMessageAndActionsStartedProject_Fragment
    | OrderWorkProjectSubItem_ContextMessageAndActions_ContextMessageAndActionsInvitedProject_Fragment;

export const YourWorkItem_StandardWorkItemFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'YourWorkItem_StandardWorkItem' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StandardWorkItem' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'stateDescription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'featuredDesignerAvatars' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'hasError' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'collaborators' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'icon' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'signedFileUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'styleVariation' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'preTranslatedDateMessage' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'actions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'openInNewTab' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'canDelete' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'deleteActionTitle' } },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                ],
            },
        },
    ],
};
export const OrderWorkProjectSubItem_ProjectFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'OrderWorkProjectSubItem_Project' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Project' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'designer' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'urlToken' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'profile' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'avatarUrl' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '__typename' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                ],
            },
        },
    ],
};
export const OrderWorkProjectSubItem_ContextMessageAndActionsFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'OrderWorkProjectSubItem_ContextMessageAndActions' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProjectContextMessageAndActions' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'ContextMessageAndActionsCompletedProject',
                            },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ContextMessageAndActionsLockedProject' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ContextMessageAndActionsStartedProject' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'finishRequestId' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ContextMessageAndActionsInvitedProject' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'awaitingPaymentInvoiceCount' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstInvoiceAmount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                ],
            },
        },
    ],
};
export const OrderWorkSubItem_ProjectFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'OrderWorkSubItem_Project' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'OrderWorkSubItemProject' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'brief' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'category' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '__typename' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'project' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: {
                                        kind: 'Name',
                                        value: 'OrderWorkProjectSubItem_Project',
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'projectContextMessageAndActions' },
                        name: { kind: 'Name', value: 'contextMessageAndActions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: {
                                        kind: 'Name',
                                        value: 'OrderWorkProjectSubItem_ContextMessageAndActions',
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'job' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'OrderWorkProjectSubItem_Project' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Project' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'designer' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'urlToken' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'profile' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'avatarUrl' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '__typename' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'OrderWorkProjectSubItem_ContextMessageAndActions' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProjectContextMessageAndActions' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'ContextMessageAndActionsCompletedProject',
                            },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ContextMessageAndActionsLockedProject' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ContextMessageAndActionsStartedProject' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'finishRequestId' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ContextMessageAndActionsInvitedProject' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'awaitingPaymentInvoiceCount' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstInvoiceAmount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                ],
            },
        },
    ],
};
export const YourWorkItem_OrderWorkItemFragmentDoc: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'YourWorkItem_OrderWorkItem' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderWorkItem' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'OrderWorkSubItemProject' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'OrderWorkSubItem_Project',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '__typename' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'OrderWorkSubItem_Project' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'OrderWorkSubItemProject' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'brief' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'category' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '__typename' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'project' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: {
                                        kind: 'Name',
                                        value: 'OrderWorkProjectSubItem_Project',
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'projectContextMessageAndActions' },
                        name: { kind: 'Name', value: 'contextMessageAndActions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: {
                                        kind: 'Name',
                                        value: 'OrderWorkProjectSubItem_ContextMessageAndActions',
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'job' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'OrderWorkProjectSubItem_Project' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Project' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'designer' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'urlToken' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'profile' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'avatarUrl' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '__typename' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'OrderWorkProjectSubItem_ContextMessageAndActions' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProjectContextMessageAndActions' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'ContextMessageAndActionsCompletedProject',
                            },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ContextMessageAndActionsLockedProject' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ContextMessageAndActionsStartedProject' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'finishRequestId' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ContextMessageAndActionsInvitedProject' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'awaitingPaymentInvoiceCount' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstInvoiceAmount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                ],
            },
        },
    ],
};
export const ListingWorkItemsDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ListingWorkItems' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'YourWorkItemsInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'yourWorkItems' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'items' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: { kind: 'Name', value: 'OrderWorkItem' },
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'YourWorkItem_OrderWorkItem',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: '__typename',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'InlineFragment',
                                                typeCondition: {
                                                    kind: 'NamedType',
                                                    name: {
                                                        kind: 'Name',
                                                        value: 'StandardWorkItem',
                                                    },
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'YourWorkItem_StandardWorkItem',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: '__typename',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '__typename' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'pageCount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'resultCount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'allCount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'inProgressCount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'completedCount' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'canceledCount' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'OrderWorkSubItem_Project' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'OrderWorkSubItemProject' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'brief' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'category' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'title' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '__typename' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'project' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: {
                                        kind: 'Name',
                                        value: 'OrderWorkProjectSubItem_Project',
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'projectContextMessageAndActions' },
                        name: { kind: 'Name', value: 'contextMessageAndActions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: {
                                        kind: 'Name',
                                        value: 'OrderWorkProjectSubItem_ContextMessageAndActions',
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'job' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'YourWorkItem_StandardWorkItem' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StandardWorkItem' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'linkUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'stateDescription' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'featuredDesignerAvatars' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'hasError' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'collaborators' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'icon' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'signedFileUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stage' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'styleVariation' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'preTranslatedDateMessage' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'actions' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'openInNewTab' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'canDelete' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'typeId' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'deleteActionTitle' } },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'YourWorkItem_OrderWorkItem' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OrderWorkItem' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                        kind: 'NamedType',
                                        name: { kind: 'Name', value: 'OrderWorkSubItemProject' },
                                    },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'OrderWorkSubItem_Project',
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '__typename' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'OrderWorkProjectSubItem_Project' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Project' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'category' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'designer' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'urlToken' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'profile' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'avatarUrl' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '__typename' },
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'OrderWorkProjectSubItem_ContextMessageAndActions' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'ProjectContextMessageAndActions' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: {
                                kind: 'Name',
                                value: 'ContextMessageAndActionsCompletedProject',
                            },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ContextMessageAndActionsLockedProject' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ContextMessageAndActionsStartedProject' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'finishRequestId' } },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    {
                        kind: 'InlineFragment',
                        typeCondition: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'ContextMessageAndActionsInvitedProject' },
                        },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'contextMessage' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'actions' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'awaitingPaymentInvoiceCount' },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstInvoiceAmount' },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                ],
            },
        },
    ],
};

/**
 * __useListingWorkItemsQuery__
 *
 * To run a query within a React component, call `useListingWorkItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListingWorkItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListingWorkItemsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListingWorkItemsQuery(
    baseOptions: Apollo.QueryHookOptions<ListingWorkItemsQuery, ListingWorkItemsQueryVariables>
) {
    return Apollo.useQuery<ListingWorkItemsQuery, ListingWorkItemsQueryVariables>(
        ListingWorkItemsDocument,
        baseOptions
    );
}
export function useListingWorkItemsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<ListingWorkItemsQuery, ListingWorkItemsQueryVariables>
) {
    return Apollo.useLazyQuery<ListingWorkItemsQuery, ListingWorkItemsQueryVariables>(
        ListingWorkItemsDocument,
        baseOptions
    );
}
export type ListingWorkItemsQueryHookResult = ReturnType<typeof useListingWorkItemsQuery>;
export type ListingWorkItemsLazyQueryHookResult = ReturnType<typeof useListingWorkItemsLazyQuery>;
export type ListingWorkItemsQueryResult = Apollo.QueryResult<
    ListingWorkItemsQuery,
    ListingWorkItemsQueryVariables
>;
